// COLORS
export const white = '0, 100%, 100%'
export const azure = '187, 100%, 42%'
export const red = '4, 90%, 58%'
export const orange = '36, 100%, 50%'
export const blue = '202, 98%, 37%'
export const green = '122, 39%, 49%'
export const gray = '40, 1%, 61%'
export const purple = '222, 69%, 63%'
export const pink = '284, 55%, 54%'
export const black = '214, 27%, 28%'


// LINE
export const lineChartDataset = (label, fill = false, bgColor, borderColor, data) => {
  return (
    {
      label,
      fill,
      backgroundColor: bgColor,
      borderColor: borderColor,
      pointBorderColor: borderColor,
      pointBackgroundColor: bgColor,//'#0bb7ca',
      pointBorderWidth: 5,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: borderColor,
      pointHoverBorderColor: 'hsla(0, 0%, 86%, 1)',
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 10,
      data: [...data]
    }
  )
}

// BAR
export const barChartDataset = (label, bgColor, borderColor, data) => {
  return (
    {
      label,
      backgroundColor: bgColor,
      borderColor: borderColor,
      data
    }
  )
}

// PIE
export const pieChartDataset = (label, bgColor, borderColor, hoverColor, data) => {
  return(
    {
      label,
      backgroundColor: bgColor,
      borderColor: borderColor,
      borderWidth: 1,
      hoverBackgroundColor: hoverColor,
      hoverBorderColor: hoverColor,
      data
    }
  )
}



// WEBPACK FOOTER //
// ./src/variables/chartSettings.jsx